<template>
  <v-container fluid tag="section">
    <v-card :loading="loading" class="rounded-lg elevation-0">
      <v-card-title>进行中的工单</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md='2' class="pr-0 pb-0">
            <v-text-field
              outlined dense
              hide-details
              clearable
              v-model='selectForm.customerName'
              @keydown="queryKeyDown()"
              clear-icon="mdi-close-circle-outline"
              label="客户名称" >
            </v-text-field>
          </v-col>
          <v-col cols="12" md='2' class="pr-0 pb-0">
            <v-text-field
              outlined dense
              hide-details
              clearable
              v-model='selectForm.productName'
              @keydown="queryKeyDown()"
              clear-icon="mdi-close-circle-outline"
              label="产品名称" >
            </v-text-field>
          </v-col>

          <v-col cols="12" md='2' class="pr-0 pb-0">
            <v-select
              :items="[{ text: '软著已分解', value: 1 },{ text: '软著未分解', value: -1 },{ text: '专利已分解', value: 2 },{ text: '专利未分解', value: -2 },{ text: '商标已分解', value: 3 },{ text: '商标未分解', value: -3 }]"
              label="分解状态"
              v-model="selectForm.decpType"
              hide-details='auto'
              outlined dense
              clearable
              @change="loadData"
              clear-icon="mdi-close-circle-outline"
            ></v-select>
          </v-col>
          <v-col cols="12" md='2' class="pr-0 pb-0">
            <v-text-field
              outlined dense
              hide-details
              clearable
              v-model='selectForm.serialNumber'
              @keydown="queryKeyDown()"
              clear-icon="mdi-close-circle-outline"
              label="合同编号" >
            </v-text-field>
          </v-col>
          <v-col cols="12" md='2' class="pr-0 pb-0">
            <base-marerial-user-select @on-change="loadData"  label='工单协同人' hide-details outlined dense v-model="selectForm.assistPersonsIds" mid :menu='$constants.SysMenu.ORDER_M_ID'></base-marerial-user-select>
          </v-col>
          <v-col cols="12" md='2'>
            <v-btn color="primary" :loading="loading" @click="loadData" class="mr-1 px-2" dark depressed>
              <v-icon>mdi-magnify</v-icon>
              查询
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <div class="my-3">
        <v-row>
          <v-col cols="12" md='3' v-for="(item, idx) in items" :key="idx">
            <v-hover v-slot="{ hover }">
              <v-card class="rounded-lg" :elevation="hover ? 2 : 0" min-height='420'>
                <v-card-title class="size-14 py-1">
                  <div class="text-truncate col-10 pl-0">{{item.product.name}}</div>
                  <v-spacer></v-spacer>
                  {{item.contract.productNumber}}个
                </v-card-title>
                <v-card-subtitle class="py-1">
                  合同编号：{{item.contract.serialNumber}}
                </v-card-subtitle>
                <v-card-text>
                  <p>
                    <v-chip small :color="item.urgentLevelId | formatOrderColor" class="mr-1" dark label>
                      {{item.urgentLevelDic.name}}
                    </v-chip>
                    <v-chip v-if="item.patentInfoList.length > 0 || item.softwareList.length > 0 || item.trademarkInfoList.length > 0" small color="teal lighten-2" class="mr-1" dark label>
                      已分解
                    </v-chip>
                    <span v-if="$constants.ProductType.Bookkeeping.indexOf(item.productId) !== -1" class="red--text">
                      {{item.contract.year}}-{{item.contract.month}}月~{{ item.contract | fmEndTime | formatMonth}}月，共{{item.contract.productNumber}}个月
                    </span>
                  </p>
                  <div class="my-2">工单时间：{{item.createTime | formatDay}}</div>
                  <div class="my-2">客户名称：{{item.customer.name}}</div>
                  <div>
                     <span v-for="(item, idx) in item.firstPersonList" class="mr-1 primary--text" :key="`key-${idx}`">
                      {{item.name}}
                    </span>
                    <span v-for="(item, idx) in item.assistPersonList" class="mr-1 blue--text" :key="idx">
                      {{item.name}}
                    </span>
                  </div>
                </v-card-text>

                <div class="px-3">
                  <v-progress-linear rounded :value="item.steps | fmProgress" color="cyan" height="12">
                    <template v-slot:default="{ value }">
                      <strong class="size-10 grey--text text--darken-2">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </div>

                <v-card-text>
                  <v-chip-group multiple v-model="item.checked" active-class="primary white--text" column>
                    <v-chip @click="chipChange(`${item.id}`, 1)" small filter :value="`${item.stepId}-1`" v-for="(item, index) in item.steps.filter(obj => (!obj.operaterId || obj.operaterId ===  $store.state.userInfo.id || $store.state.userInfo.roleIds.indexOf(1) !== -1) || item.firstPersons.indexOf($store.state.userInfo.id) !== -1)" :key="`${index}-1`">{{item.stepDic.name}}</v-chip>
                  </v-chip-group>
                </v-card-text>
                <v-card-actions class="sub-btns">
                  <v-badge
                      v-if='(item.firstPersons.indexOf($store.state.userInfo.id) !== -1 || $store.state.userInfo.roleIds.indexOf(1) !== -1) && $constants.ProductType.FaMingZhuanLi.indexOf(item.product.id) !== -1 && item.patentInfoList.length === 0'
                      bordered
                      color="teal"
                      :content="item.contract.productNumber"
                      overlap
                      class="mr-3"
                    >
                    <v-btn @click="decpModal = { show: true, data: item }" color="teal" small dark v-has="'order-info-close'"  :loading="loading">
                      分解
                    </v-btn>
                  </v-badge>
                  <v-badge
                      v-else-if='(item.firstPersons.indexOf($store.state.userInfo.id) !== -1 || $store.state.userInfo.roleIds.indexOf(1) !== -1) && $constants.ProductType.ZhuZuoQuan.indexOf(item.product.id) !== -1 && item.softwareList.length === 0'
                      bordered
                      v-has="'order-software-decp'"
                      color="teal"
                      :content="item.contract.productNumber"
                      overlap
                      class="mr-3"
                    >
                    <v-btn @click="softDecpModal = { show: true, data: item }" color="teal" small dark v-has="'order-info-close'"  :loading="loading">
                      分解
                    </v-btn>
                  </v-badge>
                  <v-badge
                      v-else-if='(item.firstPersons.indexOf($store.state.userInfo.id) !== -1 || $store.state.userInfo.roleIds.indexOf(1) !== -1) && $constants.ProductType.ShangBiao.indexOf(item.product.id) !== -1 && item.trademarkInfoList.length === 0'
                      bordered
                      v-has="'order-trademark-decp'"
                      color="teal"
                      :content="item.contract.productNumber"
                      overlap
                      class="mr-3"
                    >
                    <v-btn @click="trademarkDecpModal = { show: true, data: item }" color="teal" small dark v-has="'order-info-close'"  :loading="loading">
                      分解
                    </v-btn>
                  </v-badge>
                  <v-btn @click="stopModal = { show: true, data: item }" color="red" class="mr-1" dark small v-has="'order-info-close'" v-if='item.firstPersons.indexOf($store.state.userInfo.id) !== -1 || $store.state.userInfo.roleIds.indexOf(1) !== -1' :loading="loading">
                    终止
                  </v-btn>
                  <v-btn @click="finish(item)" color="primary" small v-has="'order-info-finish'" v-if='(item.firstPersons.indexOf($store.state.userInfo.id) !== -1 && item.finish) ||  (item.finish && $store.state.userInfo.roleIds.indexOf(1) !== -1)' :loading="loading">
                    完成
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      <v-card-text class="white pa-6 my-3 rounded-lg">
        <div v-if="!$isMobile" class="mt-n2 float-left">
          <v-text-field
            outlined
            dense
            style="width:170px;height:30px"
            hide-details
            v-model="skipPage"
            @keydown="queryKeyDown()"
            type="number"
            prefix="跳转至["
            suffix="]页"
          ></v-text-field>
        </div>
        <v-row align="center" justify="end" >
          <div class="grey--text">共 {{page.total}} 条</div>
          <v-pagination
             justify="space-around"
             :total-visible="7"
             v-model="page.current"
             :length="page.count"
             @input="nextPage"
           ></v-pagination>
        </v-row>
      </v-card-text>
    </div>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">
          <v-icon color="warning">mdi-alert</v-icon>&nbsp;
          系统提示
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <div class="text-h6 pa-2 px-0">
              确定【 {{tip}}】此工单吗？
            </div>
            <v-row>
              <v-col cols="12">
                <v-textarea rows='3' label="备注信息" hide-details='auto' outlined :rules="form.orderStatus === -1 ? required : []" v-model="form.remark"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end p4-1">
          <v-btn text small color="blue" @click="dialog = false">取消</v-btn>
          <v-btn color="primary" :loading="loading" depressed small @click="save">
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <stop-view :item='stopModal' @on-load-data='loadData'></stop-view>
    <decompose-view :item='decpModal' @on-load-data='loadData'></decompose-view>
    <decompose-soft :item='softDecpModal' @on-load-data='loadData'></decompose-soft>
    <decompose-trademark :item='trademarkDecpModal' @on-load-data='loadData'></decompose-trademark>
    <commission-settle :item='commSettleModal' @on-load-data='loadData'></commission-settle>
  </v-container>
</template>

<script>
  import { update, list } from '@/api/order/step.js'
  import { save } from '@/api/order/index.js'
  import StopView from '@/views/pages/pc/contract/info/components/Stop'
  import DecomposeView from './components/Decompose.vue'
  import DecomposeSoft from './components/DecomposeSoft.vue'
  import DecomposeTrademark from './components/DecomposeTrademark.vue'
  import CommissionSettle from './components/CommissionSettle.vue'

  export default {
    name: 'OrderStep',
    components: {
      StopView,
      DecomposeView,
      DecomposeSoft,
      CommissionSettle,
      DecomposeTrademark
    },
    filters: {
      fmEndTime (item) {
        const date = new Date(`${item.year}-${item.month - 1}`)
        date.setMonth(date.getMonth() + item.productNumber)
        return date.getTime() / 1000
      },
      fmProgress (steps) {
        const len = steps.length
        let finish = 0
        steps.forEach(step => {
          if (step.finish === 1) {
            finish += 1
          }
        })
        return len === 0 ? 0 : Math.ceil(finish / len * 100)
      }
    },
    data() {
      return {
        tip: '',
        form: {
          id: '',
          type: '',
          remark: '',
          orderStatus: ''
        },
        selectForm: {
          orderStatus: 2,
          serialNumber: '',
          assistPersonsIds: []
        },
        skipPage: '',
        page: {
          total: 0,
          count: 0,
          size: 12,
          current: 1,
          orderByField: 'if(order_status >= 0 and order_status < 3,1,0) desc,urgent_level_id desc,create_time',
          asc: false
        },
        dialog: false,
        loading: false,
        items: [],
        required: [
          value => !!value || '此项为必填项!'
        ],
        stopModal: { show: false, data: {} },
        decpModal: { show: false, data: {} },
        softDecpModal: { show: false, data: {} },
        commSettleModal: { show: false, data: {} },
        auditSettleModal: { show: false, data: {} },
        trademarkDecpModal: { show: false, data: {} },
      }
    },
    methods: {
       finish (item) {
        this.tip = '完成'
        this.form.id = item.id
        this.form.orderStatus = 4
        this.dialog = true
      },
      chipChange (id, type) {
        this.form.id = id
        this.form.type = type
        this.update()
      },
      save () {
        this.loading = true
        save(this.form).then(res => {
          if (res.status === 200) {
            this.dialog = false
            this.loadData()
            this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
          }
          this.loading = false
        })
      },
      queryKeyDown () {
        if (window.event.keyCode === 13) {
          this.page.current = Number(this.skipPage) || 1
          this.loadData()
        }
      },
      update () {
         this.loading = true
          update(this.form).then(res => {
            if (res.status === 200) {
              this.loadData()
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
      },
      loadData () {
        this.loading = true
        Object.assign(this.pageParams, this.selectForm)
        list(this.pageParams).then(res => {
          if (res.status === 200) {
            this.items = []
            this.page.count = res.data.pages
            this.page.current = res.data.current
            this.page.total = res.data.total
            res.data.records.forEach(el => {
              const checked = []
              el.steps.forEach(step => {
                checked.push(`${step.stepId}-${step.finish}`)
              })
              el.checked = checked
              el.finish = (checked.toString().split('-1')).length - 1 === el.steps.length
              this.items.push(el)
            });
          }
          this.loading = false
        })
      },
      nextPage (current) {
        this.page.current = current
        this.loadData()
      },
    },
    computed: {
      pageParams () {
        return {
          page: {
            current: this.page.current,
            size: this.page.size,
            asc: this.page.asc,
            orderByField: this.page.orderByField
          }
        }
      }
    },
    created() {
      this.loadData()
    }
  }
</script>

<style>
.sub-btns{
  position: absolute;
  bottom: 1px;
  right: 1px;
}
.order-address, .order-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
